<template>
  <div style="background-color:#fff;height: 100%;" >
    <van-sticky :offset-top="0 " >
    <mini_head_top> </mini_head_top>
    </van-sticky>
    <!-- <div style="height:calc( 100vh - 50px );overflow:auto"> -->
    <div style="overflow:auto">
      <van-swipe class="my-swipe" style="margin:5px" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for = "item in imagList " :key = "item.id"><van-image style="width:100%;height:180px" :src="item.imgUrl"  fit="cover"/> </van-swipe-item>
      </van-swipe>
      <div style="margin-top:10px"> 
        <van-row  type="flex"  justify="space-between" style="margin: auto; padding: auto; width: 100%;text-align: left">
          <van-row>
            <span style="margin-left: 5px; height:16px;width:10px;background:#38e8eb; display: inline-block"> </span>
            <span style="font-size:16px;  font-weight:700">通知公告</span>
          </van-row>
          <el-link style="margin-right: 10px;" type="warning" @click.native="goNoticeList()">更多  <i class="el-icon-d-arrow-right" style="color: #f2853d"></i></el-link>
        </van-row >
        <ul  v-if = "noticeList!= null && noticeList.length > 0" class="tzgg-ul">
          <li  @click="goShowPage(notice.id,'通知公告')" v-for="notice in noticeList" :key="notice.id" class="text tzgg-ul-li"><i class=""></i>
            <a class="">{{ notice.theme }}</a>
            <span class="">{{ notice.createTime }}</span>
          </li>  
        </ul>

        <div v-else class="tzgg-ul" style="display: flex;justify-content: center;"> 
            <el-image :src="empty" fit="cover"    style=" height: 200px;"   ></el-image>
          </div>
      </div>
      
      <div style="margin-top: 20px;"> 
        <van-row type="flex" justify="space-between" style="margin: auto;  padding: auto;text-align: left">
          <van-row>
            <span style="margin-left: 5px; height:16px;width:10px;background:#38e8eb; display: inline-block"> </span>
            <span style="font-size:16px;  font-weight:700">实验室准入教程</span>
          </van-row>
          <van-row style ="margin-right: 10px;">
            <i  v-if = "enterState.studyState >= 5" style="color: #67C23A;" class="el-icon-success"></i>
            <i  style="color: #E6A23C;cursor: pointer; margin-left:10px"  class="el-icon-refresh" @click="refreshEnterState"></i>
          </van-row>
        
        </van-row>
        <van-row>
          

          <div style="line-height: 50px;text-align: left;">
            <div style="margin-left:10px;cursor: pointer;" >
              <i  v-if = "enterState.studyState >= 1" style="color: #67C23A;" class="el-icon-success"></i>
              <i  v-else class="el-icon-success"></i>
              <span v-if = "regBasicList.length == 0"  @click = "showMessage('未配置实验室准入规章制度！')">实验室准入规章制度</span>
              <el-dropdown v-else @command="handleCommandReg" >
                <span class="el-dropdown-link" style="font-size:17px;cursor: pointer;" >
                 实验室准入规章制度<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item  divided v-for=" item in regBasicList" :command="item.id" :key="item.id">
                    <i v-if = "item.learned > 0" style="color: #67C23A;" class="el-icon-success"></i>
                    <i v-else class="el-icon-success"></i>
                    {{ item.theme }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div> 
            <div style="margin-left:10px;cursor: pointer;" >
              <i v-if = "enterState.studyState >= 2" style="color: #67C23A;" class="el-icon-success"></i>
              <i v-else class="el-icon-success"></i>
              <span v-if = "knBasicList.length == 0"  @click = "showMessage('未配置实验室准入安全知识！')">实验室准入安全知识</span>
              <el-dropdown v-else  @command="handleCommandKn" >
                <span class="el-dropdown-link" style="font-size:17px;cursor: pointer;">
                  实验室准入安全知识<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item divided v-for=" item in knBasicList" :command="item.id" :key="item.id">
                    <i  v-if = "item.learned > 0" style="color: #67C23A;" class="el-icon-success"></i>
                    <i v-else class="el-icon-success"></i>
                    {{item.theme}}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div style="margin-left:10px;cursor: pointer;">
              <i v-if = "enterState.studyState >= 3" style="color: #67C23A;" class="el-icon-success"></i>
              <i v-else class="el-icon-success"></i>
              <span @click="goBasicQm">实验室准入知识题库</span>
            </div> 
            <div style="margin-left:10px;cursor: pointer;">
              <i  v-if = "enterState.studyState >= 4" style="color: #67C23A;" class="el-icon-success"></i>
              <i v-else class="el-icon-success"></i>
              <span v-if = "examThemeBasic.id == 0 "  @click="goBasicExam">实验室准入安全考试</span>
              <el-dropdown v-else  @command="handleCommandExam">
                <span class="el-dropdown-link" style="font-size:17px;cursor: pointer;">
                  实验室准入安全考试<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-if =  "examThemeBasic.examCount == 1"  divided  :command="1" >
                    <i :style="examThemeBasic.result ? 'color: #67C23A;':''" :class="examThemeBasic.result? 'el-icon-success':'el-icon-warning'"> 考试 </i>
                  </el-dropdown-item>
                  <el-dropdown-item v-else  divided v-for=" (item,index) in examThemeBasic.examCount" :command="item" :key="index">
                    <i v-if = " item == 1"  class="el-icon-warning"> 第1次考试 </i>
                    <i v-else-if = "item < examThemeBasic.examCount && item > 1  "  class="el-icon-warning">{{ ' 第' + (item - 1) + '次重考'}} </i>
                    <i v-else :style="examThemeBasic.result ? 'color: #67C23A;':''" :class="examThemeBasic.result? 'el-icon-success':'el-icon-warning'"> 第{{item - 1}}次重考</i>
                  </el-dropdown-item>
                  <el-dropdown-item divided :command="0" v-if = "examThemeBasic.result != null && !examThemeBasic.result">
                    <i style="color: #f22004;" class="el-icon-warning" > 重考</i>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div> 
            <div style="margin-left:10px;cursor: pointer;">
              <i  v-if = "enterState.studyState >= 5" style="color: #67C23A;" class="el-icon-success"></i>
              <i  v-else class="el-icon-success"></i>
              <span  @click="goBasicSafeBook">实验室准入安全责任书</span>
            </div> 
          </div>
        </van-row>
      </div>


      <div style="margin-top: 20px;"> 
        <van-row type="flex" justify="space-between" style="margin: auto;  padding: auto;text-align: left">
          <van-row>
            <span style="margin-left: 5px; height:16px;width:10px;background:#38e8eb; display: inline-block"> </span>
          <span style="font-size:16px;  font-weight:700">知识题库</span>
          </van-row>
          <el-link type="warning" style="margin-right:10px" @click.native="goQmList()">更多  <i class="el-icon-d-arrow-right" style="color: #f2853d"></i></el-link>
        </van-row>
        <van-row>
          <van-col style="padding: 10px;"  :span ="12"  v-for = "(item, index ) in qmList" :key = "index" >
            <div style="background-color:#fff;cursor: pointer;">
              <van-image
              style="width: 100%; height: 140px ;  cursor: pointer; border-radius: 10px;"
              :src="item.coverImage"  @click="goSelfTest(item.id)"></van-image>
              <el-tag type="warning"   @click="goSelfTest(item.id)"  style="width:100%; text-align:center; font-size: 11px;">
                {{ item.moduleName }}
              </el-tag>
            </div>
          </van-col>
        </van-row>
      </div>
      <div style="margin-top: 10px;"> 
        <van-row type="flex"  justify="space-between" style="margin: auto;padding: auto; text-align: left">
          <div>
            <span style="margin-left: 5px; height:16px;width:10px;background:#38e8eb; display: inline-block"> </span>
            <span style="font-size:16px;  font-weight:700">安全知识</span>
          </div>
          <el-link type="warning" style="margin-right: 10px" @click.native="goKnList()">更多  <i class="el-icon-d-arrow-right" style="color: #f2853d"></i></el-link>
        </van-row>
        <van-row>
          <van-col :span="12" style="padding: 10px;"  class="el-col-2"  v-for = "(item) in knModelList.slice(0,4)" :key = "item.id">                                                                                                                                                                                                                                                                                                                                
            <div style="height:150px; border-radius:1px;background-color:#fff; box-shadow: 3px 3px 3px 3px rgba(39, 93, 105, 0.07)">
              <div :style=" 'text-align: center ;font-size:18px; overflow: hidden; height: 25px; background-color:#38e8eb;' ">
                {{ item.moduleName }}
              </div>
              <ul class ="m2">
                <li style="overflow:hidden;"  v-for = "(ite) in item.knList.slice(0,4)" :key = "ite.id"><a class=""  @click="goShowPage(ite.id,'安全知识')"  > {{ite.theme}}</a></li>
              </ul>
            </div>   
          </van-col>          
        </van-row>
      </div>
      <div style="margin-top: 10px;" > 
        <div style="margin: auto; padding: auto;text-align: left">
          <span style="margin-left: 5px; height:16px;width:10px;background:#38e8eb; display: inline-block"> </span>
          <span style="font-size:16px;  font-weight:700">更多内容</span>
        </div>
        <van-row>
          <van-col :span="12" style="padding: 5px;"  class="el-col-2" >                                                                                                                                                                                                                                                                                                                                
            <div @click="goExaList()" style="height:50px;display: flex; align-items: center; justify-content: center;  border-radius:1px;background-color:rgb(129, 162, 234); box-shadow: 3px 3px 3px 3px rgba(39, 93, 105, 0.07)">
              安全考试  
            </div>  
          </van-col>      
          <van-col :span="12" style="padding: 5px;"  class="el-col-2" >                                                                                                                                                                                                                                                                                                                                
            <div  @click="goStoreroomList()" style="height:50px;display: flex; align-items: center; justify-content: center;  border-radius:1px;background-color:rgb(129, 162, 234); box-shadow: 3px 3px 3px 3px rgba(39, 93, 105, 0.07)">
              安全管理  
            </div>  
          </van-col>    
        </van-row>
        <van-row>
          <van-col :span="12" style="padding: 5px;"  class="el-col-2" >                                                                                                                                                                                                                                                                                                                                
            <div  @click="goGuidList()" style="height:50px; display: flex; align-items: center; justify-content: center; border-radius:1px;background-color:rgb(129, 162, 234); box-shadow: 3px 3px 3px 3px rgba(39, 93, 105, 0.07)">
              办事指南 
            </div>   
          </van-col>    
          <van-col :span="12" style="padding: 5px;"  class="el-col-2" >                                                                                                                                                                                                                                                                                                                                
            <div @click="goRegList()" style="height:50px;display: flex; align-items: center; justify-content: center;  border-radius:1px;background-color:rgb(129, 162, 234); box-shadow: 3px 3px 3px 3px rgba(39, 93, 105, 0.07)">
              规章制度
            </div>   
          </van-col>               
        </van-row>
        <van-row>
          <van-col :span="12" style="padding: 5px;"  class="el-col-2" >                                                                                                                                                                                                                                                                                                                                
            <div @click="goMiniError()" style="height:50px;display: flex; align-items: center; justify-content: center;  border-radius:1px;background-color:rgb(129, 162, 234);box-shadow: 3px 3px 3px 3px rgba(39, 93, 105, 0.07)">
              错题集 
            </div>  
          </van-col>        
          <van-col :span="12" style="padding: 5px;"  class="el-col-2" >                                                                                                                                                                                                                                                                                                                                
            <div @click="goSafeBookList()" style="height:50px;display: flex; align-items: center; justify-content: center;  border-radius:1px;background-color:rgb(129, 162, 234); box-shadow: 3px 3px 3px 3px rgba(39, 93, 105, 0.07)">
              安全责任书  
            </div>   
          </van-col>       
        </van-row>
        <van-row>
          <van-col :span="12" style="padding: 5px;"  class="el-col-2" >                                                                                                                                                                                                                                                                                                                                
            <div @click="goMiniSelf()" style="height:50px;display: flex; align-items: center; justify-content: center;  border-radius:1px;background-color:rgb(129, 162, 234); box-shadow: 3px 3px 3px 3px rgba(39, 93, 105, 0.07)">
              个人信息 
            </div>  
          </van-col>        
        </van-row>
      </div>
    </div>
  </div>
</template>
<script>
  import logo from "@/assets/image/yuanhui.png"
  import empty from "@/assets/image/empty.png"
  import mini_head_top from "@/mini_pages/mini_head_top"
  import {MESSAGE_DURATION } from  '@/api/constant'

  import axios from  '@/api/axiosConfig'
  export default {
  components: { mini_head_top },
    name : 'mini_index',
    data () {
      return {
        empty,
        logo,
        loginForm: {
          userName: '',
          password: ''
        },
        knColorList:["#f2853d","#00ffff","#00ff00","#c8dc16"],
        noticeList :[],
        knModelList :[],
        qmList: [],
        imagList: [],
        regObj:{
          countryList :[],
          localList :[],
          otherList: []
        },
        enterState :{
          studyState : 0,
          loading : false
        },
        regBasicList  : [],
        knBasicList : [],
        qmBasic :{
          id :  0,
        },
        examThemeBasic :{
          id :0,
          examCount : 1,
          result : null
        },
        safeBookBasic :{
          id : 0
        },
        userInfo:{
          fullName :'',
          userName :'',
          imageUrl:''
        }
      }
    },
    mounted () {
      this.showLogin = true
    },
    created(){

      setTimeout(()=>{ this.noticeListLoad() },200)

      setTimeout(()=>{ this.lbtListLoad() },200)

      setTimeout(()=>{ this.knListLoad() },200)

      setTimeout(()=>{ this.qmListLoad(1) },200)

      setTimeout(()=>{ this.getUserInfo() },200)

      setTimeout(()=>{ this.enterStateLoad(false) },200)
      
    },
    methods: {
      refreshEnterState(){
        this.enterStateLoad( true )
      },
      handleCommandReg(id){
        this.viewRegOne(id,'规章制度')
      },
      viewRegOne(id,fileType){
          this.$router.push( {path: '/mini_view_editor', query: { id: id,fileType:fileType }})
      },
      handleCommandKn(id){
        if(this.enterState.studyState < 1){
          this.showMessage("请先学习实验室准入教程的规章制度")
          return
        }
        this.viewKnOne(id)
      },
      viewKnOne(id){
        this.$router.push( {path: '/mini_view_editor', query: { id: id,fileType:'安全知识' }})
      },
      goBasicQm(){
        if(this.qmBasic.id == 0){
            this.showMessage("未配置实验室准入安全知识题库")
            return
        }
        if(this.enterState.studyState < 2){
            this.showMessage("请先学习实验室准入教程的安全知识！")
            return
        }
        this.goSelfTest(this.qmBasic.id)
      },
      handleViewPaper( id,examCount){
        this.$router.push( {path: '/mini_paper', query: { id: id,examCount:examCount  }})
      },
      handleCommandExam(examCount){

        if(this.examThemeBasic.id == 0){
          this.showMessage("未配置实验室准入安全考试！")
          return
        }
        if(this.enterState.studyState < 3){
          this.showMessage("请先学习实验室准入教程的知识题库！")
          return
        }

        if(examCount == 0){
          this.handleReExamPaper(this.examThemeBasic.id) 
        }else{
          if(examCount == this.examThemeBasic.examCount ){
            this.handleViewPaper(this.examThemeBasic.id , null)
          }else{
            this.handleViewPaper(this.examThemeBasic.id , examCount)
          }
        }
      },
      handleReExamPaper(id){
      let dat = {
        themeId : id 
      }
      let url = "/bc/exa/themeUser/reExam"
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.handleViewPaper(this.examThemeBasic.id , null)
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
      },
      goBasicExam(){
        if(this.examThemeBasic.id == 0){
            this.showMessage("未配置实验室准入安全考试！")
            return
        }
        if(this.enterState.studyState < 3){
            this.showMessage("请先学习实验室准入教程的知识题库！")
            return
        }
        this.handleViewPaper(this.examThemeBasic.id, null)
      },
      enterStateLoad( refresh){
        if(this.enterState.loading){
          return
        }
        this.enterState.loading = true
        let url = "/bc/exa/enter/state"
        let dat0 = {
          
        }
        axios.post(url, dat0).then((response) => {
          this.enterState.loading = false
          if (response.data.code === 0) {
            if(refresh){

              this.$message({
              showClose: true,
              message: '刷新成功',
              type: 'success',
              duration: MESSAGE_DURATION
            })
            }
            this.enterState.studyState= 0
            this.regBasicList= []
            this.knBasicList= []
            this.qmBasic.id = 0
            this.examThemeBasic.id  = 0
            this.examThemeBasic.examCount  = 1
            this.examThemeBasic.result  = null
            this.safeBookBasic.id = 0
            let dat = response.data.data;
            if(dat.studyState != null ){
              this.enterState.studyState = dat.studyState
            }
            if( dat.bcRegLearnSearchVoList != null && dat.bcRegLearnSearchVoList.length > 0 ){
                dat.bcRegLearnSearchVoList.forEach(t=>{
                this.regBasicList.push(t)
            })
            }
            if( dat.bcKnLearnSearchVoList != null && dat.bcKnLearnSearchVoList.length > 0 ){
              dat.bcKnLearnSearchVoList.forEach(t=>{
                this.knBasicList.push(t)
              })
            }
            if(dat.bcQuestionModuleBasicVo != null ) {
              this.qmBasic.id = dat.bcQuestionModuleBasicVo.id
            }
            if(dat.bcExamThemeBasicVo != null ) {
              this.examThemeBasic.id = dat.bcExamThemeBasicVo.id
              if(dat.bcExamUserEntity != null){
                console.log(dat.bcExamUserEntity.examCount)
                this.examThemeBasic.examCount =  dat.bcExamUserEntity.examCount
                if(dat.bcExamUserEntity.result != null){
                  this.examThemeBasic.result = dat.bcExamUserEntity.result == 1
                }
              }
            }

            if(dat.bcQuestionModuleBasicVo != null ) {
              this.safeBookBasic.id = dat.bcSafeBookBasicVo.id
            }

          }else{
            this.$message({
              showClose: true,
              message: response.data.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          }
          }).catch((err)=>{
            this.enterState.loading = false
            this.$message({
              showClose: true,
              message: err.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          });
      },
      goBasicSafeBook(){
        if(this.safeBookBasic.id == 0){
          this.showMessage("未配置实验室准入安全责任书！")
          return
        }
        if(this.enterState.studyState < 4){
          this.showMessage("请先完成实验室准入安全考试！")
          return
        }
        this.viewSafeBookOne(this.safeBookBasic.id)
      },
      showMessage(message){
        this.$message({
          showClose: true,
          message: message,
          type: 'error',
          duration: MESSAGE_DURATION
        })
      },
      viewSafeBookOne(id){
        this.$router.push( {path: '/mini_safe_book_editor', query: { id: id }})
      },
      goSelfTest(id){
        this.$router.push( {path: '/mini_qb', query: { id: id}})
      },
      goExaList(){
        this.$router.push( {path: '/mini_exa_list'})
      },
      goMiniError(){
        this.$router.push( {path: '/mini_error'})
      },
      goSafeBookList(){
        this.$router.push( {path: '/mini_safe_book_list'})
      },
      goMiniSelf(){
        this.$router.push( {path: '/mini_self'})
      },
      getUserInfo(){
      let url = "/bc/exa/usr/getUsrInfo"
      let dat0 = {
      }
      axios.post(url, dat0).then((response) => {
          if (response.data.code === 0) {
            let dat = response.data.data
            if(dat!= null && dat != ''){
              this.userInfo.fullName = dat.fullName
              this.userInfo.usrName = dat.usrName  
              this.userInfo.imageUrl = dat.headImag
            } else {
              this.$message({
                showClose: true,
                message: '未查询到规章制度信息！',
                type: 'info',
                duration: MESSAGE_DURATION
              })
            }
          }else{
            this.$message({
              showClose: true,
              message: response.data.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          }
          }).catch((err)=>{
            this.$message({
              showClose: true,
              message: err.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          });
      },
      goNoticeList(){
        this.$router.push({path:'/mini_notice_list'})
      },
      goShowPage(id,fileType){
        this.$router.push( {path: '/mini_view_editor', query: { id: id,fileType:fileType}})
      },
      goQmList(){
        this.$router.push({path:'/mini_qm_list'})
      },
      goKnList(){
        this.$router.push({path:'/mini_kn_list'})
      },
      goGuidList(){
        this.$router.push({path:'/mini_guid_list'})
      },
      goRegList(){
        this.$router.push({path:'/mini_reg_list'})
      },
      goStoreroomList(){
        this.$router.push({path:'/mini_storeroom'})
      },
      noticeListLoad(){
      let url = "/bc/exa/notice/noticePage"
      let dat0 = {
        pageSize: 5,
        pageNo:1,
        active:1
      }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          let dat = response.data.data
          if(dat.data.length !== 0){
              this.noticeList = [];
              dat.data.forEach(t=>this.noticeList.push(t))
          } else {
            // this.$message({
            //   showClose: true,
            //   message: '未查询到通知信息！',
            //   type: 'info',
            //   duration: MESSAGE_DURATION
            // })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch((err)=>{
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
      });
      },
      qmListLoad(pageNo){
        let url = "/bc/exa/qm/qmPage"
        let dat0 = {
          pageSize: 4,
          pageNo,
          active:1,

          adminInfInvoke: false
        }
        axios.post(url, dat0).then((response) => {
          if (response.data.code === 0) {
            let dat = response.data.data
            if(dat.data.length !== 0){
              this.qmList = []
              dat.data.forEach(t=>this.qmList.push(t))
            } else {
              this.$message({
                showClose: true,
                message: '未查询到安全知识信息！',
                type: 'info',
                duration: MESSAGE_DURATION
              })
            }
          }else{
            this.$message({
              showClose: true,
              message: response.data.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          }
          }).catch((err)=>{
            this.$message({
              showClose: true,
              message: err.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          });
      },
      lbtListLoad(){
        let url = "/bc/exa/carousel/carouselPage"
        let dat0 = {
          pageSize: 5,
          active:1,
          pageNo:1
        }
        axios.post(url, dat0).then((response) => {
          if (response.data.code === 0) {
            let dat = response.data.data
            if(dat.data.length !== 0){
                this.imagList = []
                dat.data.forEach(t=>this.imagList.push(t))
            } else {
              this.$message({
                showClose: true,
                message: '未查询轮播图信息！',
                type: 'info',
                duration: MESSAGE_DURATION
              })
            }
          }else{
            this.$message({
              showClose: true,
              message: response.data.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          }
          }).catch( (err)=> {
            this.$message({
              showClose: true,
              message: err.message,
              type: 'error',
              duration: MESSAGE_DURATION
          })
        });
      },
      knListLoad(){
        let url = "/bc/exa/kn/knHomePage"
        let dat0 = {
        }
        axios.post(url, dat0).then((response) => {
          if (response.data.code === 0) {
            let dat = response.data.data
            if(dat.length !== 0){
                this.knModelList = []
                dat.forEach(t=>this.knModelList.push(t))
            } else {
              this.$message({
                showClose: true,
                message: '未查询轮播图信息！',
                type: 'info',
                duration: MESSAGE_DURATION
              })
            }
          }else{
            this.$message({
              showClose: true,
              message: response.data.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          }
          }).catch( (err)=> {
            this.$message({
              showClose: true,
              message: err.message,
              type: 'error',
              duration: MESSAGE_DURATION
          })
        });
      }
    },
    components:{
      mini_head_top
    }
  }
</script>

<style lang="less" scoped>
.headImag{
  width: 40px;
  height: 40px;
  border-radius: 50%;

}

 .my-swipe .van-swipe-item {
    color: #fff;
    font-size: 20px;
    height: 180px;
    text-align: center;
    background-color: #fff;
  }
/deep/.m2{
  line-height: 20px;
  text-align: center;
  margin-top: 8px;
  li{
    margin:5px;
    a {
      cursor: pointer;
      overflow: hidden;
      padding-left: 0.5;
      white-space: nowrap;
      text-overflow: ellipsis;
      display: inline-block;
      text-align: center;
      font-size: 14px;
    }
  }
}
  .tzgg-ul{
    cursor: pointer;
    &:first-child {
      margin-top: 20px;
    }
    height: 200px;
    .tzgg-ul-li{
      cursor: pointer;
      height: 40px;
      line-height: 20px;
      margin:5px;
      i{
        width:5px;
        height:5px;
        display:inline-block;
        background: #6F6F6F;
        margin-bottom: 5px;
        margin-left: 5px;
        transform:rotate(45deg);
      }
      a{
        width:60%;
        overflow: hidden;
        padding-left: 1em;
        white-space: nowrap;
        text-overflow: ellipsis;
        display: inline-block;
        text-align: left;
        font-size: 1em;
      }
      span{
        width:30%;
        display:inline-block;
        font-size: 1em;
        color: #6F6F6F;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/mini_pages/mini_index.vue